import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { UserPermissionsService } from '../services/user-permissions.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appHasPermission]',
  standalone: true
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private permissionKey: string = '';
  private subscription?: Subscription;
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionsService: UserPermissionsService
  ) {}

  @Input() set appHasPermission(permissionKey: string) {
    this.permissionKey = permissionKey;
    this.updateView();
  }

  ngOnInit(): void {
    // Carregar permissões uma vez (a promise compartilhada evitará múltiplas chamadas)
    this.permissionsService.loadUserPermissions().then(() => {
      // Inscrever-se nas mudanças de permissões
      this.subscription = this.permissionsService.userPermissions$.subscribe(() => {
        this.updateView();
      });

      // Verificar permissão inicial após carregar
      this.updateView();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private updateView(): void {
    // Não precisa aguardar loadUserPermissions aqui, pois a diretiva já está inscrita
    // no userPermissions$ que será atualizado quando as permissões forem carregadas
    // Isso evita múltiplas chamadas simultâneas
    const hasPermission = this.permissionsService.hasPermission(this.permissionKey);

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
